let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("95GQ6")).then(() => parcelRequire('9prXl'));